import { fcfa } from '../lib/api';
import { Button } from '../components/ui/button';
import { Trophy, Gavel, Users, Wallet, X, Eye, Heart } from 'lucide-react';

export function LiveStatsModal({ stats, onClose }) {
  if (!stats) return null;
  const cards = [
    { icon: Wallet, label: 'Total vendu', value: fcfa(stats.total_sold || 0), color: 'text-amber-400', id: 'total' },
    { icon: Gavel, label: 'Enchères', value: stats.bids_count, color: 'text-sky-400', id: 'bids' },
    { icon: Trophy, label: 'Articles vendus', value: `${stats.sold_count}/${stats.auctions_count}`, color: 'text-emerald-400', id: 'sold' },
    { icon: Users, label: 'Enchérisseuses', value: stats.unique_bidders, color: 'text-rose-400', id: 'bidders' },
    { icon: Eye, label: 'Visites · pic en ligne', value: `${stats.visits ?? 0} · ${stats.peak_viewers ?? 0}`, color: 'text-violet-400', id: 'visits' },
    { icon: Heart, label: 'Cœurs reçus', value: stats.hearts ?? 0, color: 'text-rose-500', id: 'hearts' },
  ];
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" data-testid="live-stats-modal" onClick={onClose}>
      <div className="card-elev rounded-3xl p-6 w-full max-w-lg space-y-5" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="text-xs uppercase tracking-widest text-slate-400">Récap du live</div>
            <h3 className="font-display text-2xl font-extrabold" data-testid="live-stats-title">{stats.title || 'Live terminé'}</h3>
          </div>
          <button onClick={onClose} data-testid="live-stats-close" className="text-slate-400 hover:text-white"><X className="h-5 w-5" /></button>
        </div>
        <div className="grid grid-cols-2 gap-3">
          {cards.map(({ icon: Icon, label, value, color, id }) => (
            <div key={id} className="rounded-2xl bg-slate-900/60 border border-slate-800 p-4" data-testid={`live-stat-${id}`}>
              <Icon className={`h-5 w-5 ${color}`} />
              <div className="mt-2 text-2xl font-extrabold">{value}</div>
              <div className="text-xs text-slate-400">{label}</div>
            </div>
          ))}
        </div>
        <div>
          <div className="text-sm font-bold mb-2 flex items-center gap-2"><Trophy className="h-4 w-4 text-amber-400" />Meilleures acheteuses</div>
          {stats.top_buyers?.length ? (
            <ol className="space-y-1" data-testid="live-top-buyers">
              {stats.top_buyers.map((b, i) => (
                <li key={b.user_id} className="flex items-center justify-between text-sm rounded-xl bg-slate-900/40 px-3 py-2">
                  <span><span className="text-slate-500 mr-2">#{i + 1}</span>{b.name || 'Acheteuse'}</span>
                  <span className="text-slate-400">{b.wins} gagné{b.wins > 1 ? 's' : ''} · {b.bids} enchère{b.bids > 1 ? 's' : ''} · <span className="text-amber-400 font-bold">{fcfa(b.spent)}</span></span>
                </li>
              ))}
            </ol>
          ) : <div className="text-sm text-slate-500" data-testid="live-top-buyers-empty">Aucune enchère sur ce live.</div>}
        </div>
        <Button onClick={onClose} className="w-full btn-brand text-white" data-testid="live-stats-ok">Fermer</Button>
      </div>
    </div>
  );
}
